import React from 'react';
import styles from './Subhead.module.scss';

export function Subhead({ children }) {
  return <h3 className={styles.subhead}>{children}</h3>;
}
